import type { Theme } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import React from "react";

import Lozenge from "@components/Lozenge/Lozenge";

import type { FieldRenderer } from "../types";

export type StateColorFn = (state: string, palette: Theme["palette"]) => string;

const StateLozenge = styled(Lozenge)({
  width: 110,
});

const StateRenderer = React.memo(function StateRenderer({
  state,
  getTextColor,
  getBackgroundColor,
}: {
  state: string;
  getTextColor: StateColorFn;
  getBackgroundColor: StateColorFn;
}) {
  const theme = useTheme();
  return (
    <StateLozenge
      label={state}
      textColor={getTextColor(state, theme.palette)}
      backgroundColor={getBackgroundColor(state, theme.palette)}
      size="normal"
    />
  );
});

export function createStateRenderer(
  getTextColor: StateColorFn,
  getBackgroundColor: StateColorFn,
): FieldRenderer {
  return (fieldValue: unknown) => {
    const stateString = String(fieldValue);
    return {
      formattedText: stateString,
      node: (
        <StateRenderer
          state={stateString}
          getTextColor={getTextColor}
          getBackgroundColor={getBackgroundColor}
        />
      ),
    };
  };
}
